export default "__VITE_ASSET__nvX8GvjG__"